export function isAppWebView(): boolean {
  return document.querySelector('meta[name="app-webview"]')?.getAttribute('content') === 'true'
}
